import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaEye, FaTimes } from "react-icons/fa";
import { useGroupPermissions } from "@/hooks/use-group-permissions";
import { Button } from "@/components/ui/button";

export function ViewOnlyBanner() {
  const { t } = useTranslation();
  const { canView, canEdit, isLoading } = useGroupPermissions();
  const [dismissed, setDismissed] = useState(false);

  if (isLoading || dismissed || !canView || canEdit) {
    return null;
  }

  return (
    <div
      className="bg-blue-50 dark:bg-blue-950/30 border-b border-blue-200 dark:border-blue-800 px-4 py-2 flex items-center justify-between gap-3 text-sm"
      role="status"
    >
      <div className="flex items-center gap-2 text-blue-800 dark:text-blue-200">
        <FaEye className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span>{t("groups.viewOnlyBanner", "You have view-only access in this group.")}</span>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 shrink-0 text-blue-800 dark:text-blue-200"
        onClick={() => setDismissed(true)}
        aria-label={t("common.dismiss", "Dismiss")}
      >
        <FaTimes className="h-4 w-4" />
      </Button>
    </div>
  );
}
